import { observer } from 'mobx-react-lite'
import { Icon, Tooltip, Typography } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import styles from './styles.module.scss'

type ITotalSecondLineProps = {
  gracePeriod: number
  total: number
}

export const TotalSecondLine = observer(({ gracePeriod, total }: ITotalSecondLineProps) => {
  return (
    <div className={styles.secondLine}>
      <Typography
        ariaLabel={'Second Line Title'}
        variant='body-lg-medium'
        color='var(--content-secondary-primary)'
      >
        Total due in {gracePeriod} hour{gracePeriod !== 1 ? 's' : ''}
        <Tooltip
          type='description'
          placement='top'
          maxWidth='none'
          label={
            <span style={{ whiteSpace: 'nowrap' }}>
              {`You have ${gracePeriod} hour${
                gracePeriod !== 1 ? 's' : ''
              } to assign or remove your numbers.`}
            </span>
          }
          desc={'After that, you’ll only be charged for any unpaid licenses.'}
        >
          <Icon
            className={styles.secondLineTooltip}
            icon={'question'}
            fontSize={14}
            color='var(--content-neutral-primary)'
          />
        </Tooltip>
      </Typography>
      <Typography
        ariaLabel={'Second Line Value'}
        variant={'body-lg-medium'}
        color='var(--content-secondary-primary)'
      >
        {numberFormat({ value: total, currency: 'USD', minimumFractionDigits: 2 })}
      </Typography>
    </div>
  )
})
